export const socialMediaGettingStartedArticle = {
  title: 'Social Media Planner: Getting Started',
  slug: 'social-media-getting-started',
  content: `Social Media Planner: Getting Started

Plan, compose, and schedule posts across channels.

1) Open the planner
- Go to /marketing/social-media-planner.

2) Choose a view
- Views include calendar, queue, analytics, media, campaigns, and accounts.
- You can also set ?view=accounts in the URL.

3) Compose posts
- Use the composer to draft and schedule posts.
- Set platform and schedule date when needed.

4) Review scheduled posts
- Calendar and Queue show upcoming content.
`,
};
